import { render, staticRenderFns } from "./erMenuItem.vue?vue&type=template&id=b4fae08c"
import script from "./erMenuItem.vue?vue&type=script&lang=js"
export * from "./erMenuItem.vue?vue&type=script&lang=js"
import style0 from "./erMenuItem.vue?vue&type=style&index=0&id=b4fae08c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports